import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const List = styled.div`
  margin: 0;

  .swiper {
    width: 100vw;
  }

  .swiper-slide {
    width: max-content;
  }

  ${mq.smallOnly} {
    text-align: center;

    .swiper {
      padding-inline: 1.2rem;
    }
  }

  ${mq.medium} {
    width: 0;
    flex-grow: 1;

    .swiper {
      width: auto;
      padding-block: 0.5rem;
    }
  }
`

export const Highlight = styled(motion.span)`
  position: absolute;
  inset: 0;
  background-color: white;
  z-index: -1;
`

export const SortingOptions = styled(List)`
  text-align: center;
  font-size: 1.8rem;
  width: max-content;
  margin: 0 auto;
  border-radius: 10em;
  padding: 0.4rem;
  background-color: rgba(26, 57, 72, 0.133);

  button {
    all: unset;
    position: relative;
    padding: 0 1rem;
    z-index: 0;

    ${mq.medium} {
      padding: 0 1.2rem;
      line-height: 3rem;
      font-size: 1.5rem;
    }

    &:not(:disabled) {
      cursor: pointer;
      z-index: 1;
    }
  }

  ${mq.smallOnly} {
    display: flex;
    align-items: center;

    button {
      height: 3rem;
    }

    &::before {
      content: url("data:image/svg+xml,%3Csvg width='25' height='18' viewBox='0 0 25 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.57613 16.7551L6.92969 17.1087L7.28324 16.7551L12.2832 11.7551L12.6368 11.4016L12.2832 11.048L10.8732 9.63804L10.5204 9.28517L10.1668 9.63735L8.42969 11.3678V2.5988V2.0988H7.92969H5.92969H5.42969V2.5988V11.3678L3.69256 9.63735L3.339 9.28517L2.98613 9.63804L1.57613 11.048L1.22258 11.4016L1.57613 11.7551L6.57613 16.7551Z' fill='white'/%3E%3Cpath d='M18.9131 1.2451L18.5596 0.891548L18.206 1.2451L13.206 6.2451L12.8525 6.59865L13.206 6.95221L14.616 8.36221L14.9689 8.71508L15.3224 8.36289L17.0596 6.63247L17.0596 15.4014L17.0596 15.9014L17.5596 15.9014L19.5596 15.9014L20.0596 15.9014L20.0596 15.4014L20.0596 6.63247L21.7967 8.36289L22.1503 8.71508L22.5031 8.36221L23.9131 6.95221L24.2667 6.59866L23.9131 6.2451L18.9131 1.2451Z' fill='white' /%3E%3C/svg%3E%0A");
      display: block;
      height: 1.8rem;
      margin: 0 1rem 0 0.6rem;
    }

    [data-type] {
      font-size: 0;

      &::before {
        display: block;
        opacity: 0.4;
        transition: opacity 0.6s;
        content: url("data:image/svg+xml,%3Csvg width='18' viewBox='0 0 22 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.35774 0.958008H4.77811C4.70415 0.958008 4.63401 0.973549 4.56606 0.995631C4.22655 1.10574 3.97559 1.46821 3.97559 1.90301V2.302V3.32327V3.85461C3.97559 3.95334 3.99203 4.04662 4.01589 4.13593C4.11806 4.51958 4.41871 4.79961 4.77811 4.79961H5.35774C5.80105 4.79961 6.16026 4.37657 6.16026 3.85461V3.32327V2.302V1.90301C6.16026 1.38105 5.80105 0.958008 5.35774 0.958008Z' fill='%231A3948'/%3E%3Cpath d='M16.7659 0.958008H16.1863C15.743 0.958008 15.3838 1.38105 15.3838 1.90301V2.302V3.32327V3.85461C15.3838 4.37657 15.743 4.79961 16.1863 4.79961H16.7659C17.2092 4.79961 17.5685 4.37657 17.5685 3.85461V3.32327V2.302V1.90301C17.5683 1.38105 17.2091 0.958008 16.7659 0.958008Z' fill='%231A3948'/%3E%3Cpath d='M19.7273 3.32715H18.2921V3.85849C18.2921 4.77834 17.6077 5.52665 16.7665 5.52665H16.1868C15.3456 5.52665 14.6611 4.77834 14.6611 3.85849V3.32715H6.88359V3.85849C6.88359 4.77834 6.19911 5.52665 5.3579 5.52665H4.77828C3.93703 5.52665 3.25259 4.77834 3.25259 3.85849V3.32715H2.00211C1.20555 3.32715 0.55957 3.93279 0.55957 4.67946V22.6901C0.55957 23.4382 1.20552 24.0424 2.00211 24.0424H19.7271C20.5243 24.0424 21.1696 23.438 21.1696 22.6901V4.67965C21.1698 3.93298 20.5245 3.32715 19.7273 3.32715ZM19.28 22.0573L2.39675 22.0508V7.5305H19.28V22.0573Z' fill='%231A3948'/%3E%3Cpath d='M12.6727 11.028H17.1129C17.4984 11.028 17.8101 10.6431 17.8101 10.1675C17.8101 9.69177 17.4982 9.30688 17.1129 9.30688H12.6727C12.2873 9.30688 11.9756 9.69177 11.9756 10.1675C11.9756 10.6429 12.2873 11.028 12.6727 11.028Z' fill='%231A3948'/%3E%3Cpath d='M12.6727 14.1331H17.1129C17.4984 14.1331 17.8101 13.7482 17.8101 13.2725C17.8101 12.7969 17.4982 12.412 17.1129 12.412H12.6727C12.2873 12.412 11.9756 12.7969 11.9756 13.2725C11.9756 13.7482 12.2873 14.1331 12.6727 14.1331Z' fill='%231A3948'/%3E%3Cpath d='M12.6727 17.2468H17.1129C17.4984 17.2468 17.8101 16.8618 17.8101 16.3862C17.8101 15.9106 17.4982 15.5256 17.1129 15.5256H12.6727C12.2873 15.5256 11.9756 15.9106 11.9756 16.3862C11.9756 16.8618 12.2873 17.2468 12.6727 17.2468Z' fill='%231A3948'/%3E%3Cpath d='M12.6727 20.351H17.1129C17.4984 20.351 17.8101 19.9661 17.8101 19.4905C17.8101 19.0148 17.4982 18.6299 17.1129 18.6299H12.6727C12.2873 18.6299 11.9756 19.0148 11.9756 19.4905C11.9756 19.9661 12.2873 20.351 12.6727 20.351Z' fill='%231A3948'/%3E%3Cpath d='M4.80847 11.028H9.24868C9.6341 11.028 9.94579 10.6431 9.94579 10.1675C9.94579 9.69177 9.63391 9.30688 9.24868 9.30688H4.80847C4.42301 9.30688 4.11133 9.69177 4.11133 10.1675C4.11137 10.6429 4.42301 11.028 4.80847 11.028Z' fill='%231A3948'/%3E%3Cpath d='M4.80847 14.1331H9.24868C9.6341 14.1331 9.94579 13.7482 9.94579 13.2725C9.94579 12.7969 9.63391 12.412 9.24868 12.412H4.80847C4.42301 12.412 4.11133 12.7969 4.11133 13.2725C4.11137 13.7482 4.42301 14.1331 4.80847 14.1331Z' fill='%231A3948'/%3E%3Cpath d='M4.80847 17.2468H9.24868C9.6341 17.2468 9.94579 16.8618 9.94579 16.3862C9.94579 15.9106 9.63391 15.5256 9.24868 15.5256H4.80847C4.42301 15.5256 4.11133 15.9106 4.11133 16.3862C4.11133 16.8618 4.42301 17.2468 4.80847 17.2468Z' fill='%231A3948'/%3E%3Cpath d='M4.80847 20.351H9.24868C9.6341 20.351 9.94579 19.9661 9.94579 19.4905C9.94579 19.0148 9.63391 18.6299 9.24868 18.6299H4.80847C4.42301 18.6299 4.11133 19.0148 4.11133 19.4905C4.11137 19.9661 4.42301 20.351 4.80847 20.351Z' fill='%231A3948'/%3E%3C/svg%3E%0A");
      }

      &:disabled::before {
        opacity: 1;
      }
    }

    [data-type='tatar']::before {
      content: url("data:image/svg+xml,%3Csvg width='23' height='15' viewBox='0 0 23 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.4029 3.66H7.91691V15H4.45191V3.66H0.96591L0.81891 0.93H11.5499L11.4029 3.66ZM19.2502 15L18.5362 12.207H14.6302L13.8952 15H10.5142C10.5282 14.79 10.5492 14.559 10.5772 14.307C10.6192 14.055 10.6892 13.796 10.7872 13.53L14.7142 0.971999L18.6832 0.887999L22.3582 13.488C22.4422 13.768 22.5052 14.034 22.5472 14.286C22.6032 14.538 22.6312 14.776 22.6312 15H19.2502ZM16.6462 4.416L15.3022 9.603H17.8852L17.2972 7.314L16.7302 4.416H16.6462Z' fill='%231A3948'/%3E%3C/svg%3E%0A");
    }

    [data-type='en']::before {
      content: url("data:image/svg+xml,%3Csvg width='23' height='15' viewBox='0 0 23 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.644758 15L0.665758 0.93H9.40176L9.27576 3.618H4.13076V6.516H8.05776V9.162H4.13076V12.312H9.27576L9.42276 15H0.644758ZM22.6708 0.93V15H19.1218L15.1528 7.608L14.1448 5.319H14.0818L14.2498 7.839V15H11.2678V0.93H14.9848L18.7648 8.049L19.8148 10.485H19.8568L19.6888 7.818V0.93H22.6708Z' fill='%231A3948'/%3E%3C/svg%3E%0A");
    }

    [data-type='ru']::before {
      content: url("data:image/svg+xml,%3Csvg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.98838 10.842C4.82038 10.842 4.64538 10.835 4.46338 10.821C4.29538 10.807 4.12038 10.793 3.93838 10.779V15H0.452375V1.056C0.942375 0.972 1.55138 0.895 2.27938 0.825C3.02138 0.755 3.75638 0.72 4.48438 0.72C6.45838 0.72 7.99838 1.105 9.10438 1.875C10.2244 2.645 10.7844 3.835 10.7844 5.445C10.7844 6.215 10.6514 6.929 10.3854 7.587C10.1194 8.245 9.74138 8.819 9.25138 9.309C8.76138 9.785 8.15238 10.163 7.42438 10.443C6.71038 10.709 5.89838 10.842 4.98838 10.842ZM4.90438 3.513C4.77838 3.513 4.63138 3.52 4.46338 3.534C4.29538 3.534 4.12038 3.541 3.93838 3.555V8.154C4.07838 8.168 4.21138 8.182 4.33738 8.196C4.47738 8.196 4.59638 8.196 4.69438 8.196C4.98838 8.196 5.26838 8.168 5.53438 8.112C5.81438 8.042 6.04538 7.937 6.22738 7.797C6.49338 7.615 6.71038 7.349 6.87838 6.999C7.06038 6.649 7.15138 6.208 7.15138 5.676C7.15138 4.878 6.95538 4.318 6.56338 3.996C6.17138 3.674 5.61838 3.513 4.90438 3.513ZM19.8649 9.792C19.5289 10.674 19.1789 11.458 18.8149 12.144C18.4649 12.816 18.0659 13.383 17.6179 13.845C17.1699 14.293 16.6379 14.636 16.0219 14.874C15.4199 15.098 14.6989 15.21 13.8589 15.21C13.4669 15.21 13.1169 15.189 12.8089 15.147C12.5149 15.119 12.2979 15.077 12.1579 15.021V12.27C12.8299 12.256 13.4949 12.207 14.1529 12.123C14.8109 12.025 15.3849 11.752 15.8749 11.304L11.6959 2.253C11.5839 2.015 11.4999 1.791 11.4439 1.581C11.3879 1.371 11.3599 1.154 11.3599 0.93H14.8669L17.4919 7.818L19.6759 0.93H23.0779C23.0639 1.112 23.0359 1.322 22.9939 1.56C22.9519 1.784 22.8819 2.015 22.7839 2.253L19.8649 9.792Z' fill='%231A3948'/%3E%3C/svg%3E%0A");
    }
  }
`

export const FilterButton = styled.button<{
  $color?: string
  $active: boolean
}>`
  padding: 0.6rem 0.8em 0.6rem 0;
  margin: 0.3333em;
  border: 1px solid currentColor;
  border-radius: 2em;
  font-size: 1.5rem;

  &::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    border-radius: 2em;
    width: 1.3333em;
    height: 1.3333em;
    margin: 0.3333em;
    background-color: ${props => props.$color || 'currentColor'};
  }

  ${props =>
    props.$active
      ? css`
          color: white;
          border-color: var(--text-color);
          background-color: var(--text-color);
        `
      : css`
          cursor: pointer;

          &:hover {
            border-color: #1a394855;
            background-color: #1a394822;
          }
        `}
`

export const SearchForm = styled.form`
  position: relative;
  align-self: stretch;

  ${mq.medium} {
    align-self: center;
  }
`

export const SearchField = styled.input`
  all: unset;
  box-sizing: border-box;
  padding: 0.4em 0.8em 0.4em 2em;
  width: 100%;
  border: 1px solid #1a3948;

  ${mq.medium} {
    width: 12em;
  }
`

export const SearchSubmit = styled.button`
  all: unset;
  display: flex;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  padding: 0.6em;

  svg {
    display: block;
  }
`
